// Identificar bandeira do cartão pelo número
export const getCardBrand = (cardNumber) => {
  if (!cardNumber) return 'UNKNOWN';
  
  const number = cardNumber.toString().replace(/\s/g, '');
  
  // Visa: começa com 4
  if (/^4/.test(number)) {
    return 'VISA';
  }
  
  // Mastercard: 51-55 ou 2221-2720
  if (/^5[1-5]/.test(number) || /^2(22[1-9]|2[3-9][0-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)/.test(number)) {
    return 'MASTERCARD';
  }
  
  // Elo: 4011, 4312, 4389, 4514, 4576, 5041, 5066, 5067, 509, 6277, 6362, 6363, 650, 6516, 6550
  if (/^(4011|4312|4389|4514|4576|5041|5066|5067|509|6277|6362|6363|650|6516|6550)/.test(number)) {
    return 'ELO';
  }
  
  // American Express: 34 ou 37
  if (/^3[47]/.test(number)) {
    return 'AMEX';
  }
  
  // Diners: 36, 38, 300-305
  if (/^3(0[0-5]|[68])/.test(number)) {
    return 'DINERS';
  }
  
  // Discover: 6011, 622126-622925, 644-649, 65
  if (/^(6011|65|64[4-9]|622(1(2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9([01][0-9]|2[0-5])))/.test(number)) {
    return 'DISCOVER';
  }
  
  // Hipercard: 606282, 637095, 637568, 637599, 637609, 637612
  if (/^(606282|637095|637568|637599|637609|637612)/.test(number)) {
    return 'HIPERCARD';
  }
  
  return 'UNKNOWN';
};

// Retornar logo da bandeira
export const getCardBrandLogo = (brand) => {
  const logos = {
    'VISA': 'https://grubicons.s3.us-east-1.amazonaws.com/Visa-Electron-01.png',
    'MASTERCARD': 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg',
    'ELO': 'https://grubicons.s3.us-east-1.amazonaws.com/bandera-elo.svg',
    'AMEX': 'https://grubicons.s3.us-east-1.amazonaws.com/amex-logo.svg',
    'DINERS': 'https://grubicons.s3.us-east-1.amazonaws.com/diners-logo.svg',
    'DISCOVER': 'https://grubicons.s3.us-east-1.amazonaws.com/discover-logo.svg',
    'HIPERCARD': 'https://grubicons.s3.us-east-1.amazonaws.com/hipercard-logo.svg',
    'NUBANK': 'https://grubicons.s3.us-east-1.amazonaws.com/nubank-logo-3-1.png',
    'MAESTRO': 'https://grubicons.s3.us-east-1.amazonaws.com/maestro-logo.png',
    'VISA_ELECTRON': 'https://grubicons.s3.us-east-1.amazonaws.com/Visa-Electron-01.png',
    'ELO_DEBIT': 'https://grubicons.s3.us-east-1.amazonaws.com/bandera-elo.svg',
    'MASTERCARD_MAESTRO': 'https://grubicons.s3.us-east-1.amazonaws.com/maestro-logo.png',
    'UNKNOWN': null
  };
  
  return logos[brand] || null;
};

// Retornar nome formatado da bandeira
export const getCardBrandName = (brand) => {
  const names = {
    'VISA': 'VISA',
    'MASTERCARD': 'MASTERCARD',
    'ELO': 'ELO',
    'AMEX': 'AMEX',
    'DINERS': 'DINERS',
    'DISCOVER': 'DISCOVER',
    'HIPERCARD': 'HIPERCARD',
    'UNKNOWN': 'CARTÃO'
  };
  
  return names[brand] || 'CARTÃO';
};
